$color-grey: #002046;

.addressSelected {
  background-color: $color-grey !important;

  &:hover {
    background-color: $color-grey;
  }
}

.addresslist__listItem {
  background-color: white;
  font-size: 1rem;
}
